import React, { useEffect } from "react";
import Layout from "./layout";
import {
  ProgressBar,
  Card,
  Row,
  Col,
  Button,
  Form,
  Alert,
} from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import { Controller, set, useForm } from 'react-hook-form';
import toast from "react-hot-toast";
import { useProfileApi } from "../store/api/hooks/profileApiHook";
import Error from "../components/formFieldError";
import { APIS } from "../_config";
import { useToken, useUser } from "../store/api/hooks/authHook";
import { useMasterApi } from "../store/api/hooks/masterApiHook";
import Select from "react-select";
import { getSelectedValue } from "../_common/functions";

const Profile: React.FC = () => {
  const progressValue = 80; // Adjust progress value here
  const profileAPI: any = useProfileApi();
  const masterAPI: any = useMasterApi();
  const tokenData: any = useToken();
  const userData: any = useUser();
  const [userImg, setUserImg] = React.useState<string>("");
  const [companyImg, setCompanyImg] = React.useState<string>("");

  const { control, formState: { errors }, handleSubmit, reset } = useForm();

  const [salutationList, setSalutationList] = React.useState<any[]>([{ value: 1, label: 'Mr.' }, { value: 2, label: 'Ms.' }, { value: 3, label: 'Mrs.' }]);
  const [licensesList, setLicensesList] = React.useState<any[]>([]);
  const [languagesList, setLanguagesList] = React.useState<any[]>([]);
  const [stateList, setStateList] = React.useState<any[]>([]);

  useEffect(() => {
    masterAPI.getLicensesList({}, (msg: any, resp: any) => {
      let licenses = resp?.data?.list?.data?.map((item: any) => {
        return { value: item.slug, label: item.title };
      });
      setLicensesList(licenses);
    }, (msg: any) => {
      console.log('msg==========', msg)
    })
    masterAPI.getLanguagesList({}, (msg: any, resp: any) => {
      let languages = resp?.data?.list?.data?.map((item: any) => {
        return { value: item.slug, label: item.title };
      });
      setLanguagesList(languages);
    }, (msg: any) => {
      console.log('msg==========', msg)
    })
    masterAPI.getMasterModuleList({ modules: 'states' }, (msg: any, resp: any) => {
      let modules = resp?.data?.states?.map((item: any) => {
        return { value: item.id, label: item.state_name };
      });
      setStateList(modules);
    }, (msg: any) => {
      console.log('msg==========', msg)
    })
  }, [userData]);


  useEffect(() => {
    reset({
      salutation: userData?.salutation,
      first_name: userData?.first_name,
      last_name: userData?.last_name,
      phone: userData?.phone,
      about: userData?.about,
      company_name: userData?.company?.name,
      license_number: userData?.company?.license_number,
      website: userData?.company?.website,
      address: userData?.company?.address,
      branch_address: userData?.company?.branch_address,
      local_address: userData?.company?.local_address,
      city: userData?.company?.city,
      state: userData?.company?.state,
      zip: userData?.company?.zip,

    })
    setUserImg(userData?.avatar?.thumb);
    setCompanyImg(userData?.company?.logo?.thumb);
  }, [userData]);


  const fileUploadImg = (params: any, type = 'profile') => {
    return new Promise((resolve, reject) => {
      fetch((type == 'company') ? APIS.PROFILE.COMPANY_LOGO_UPDATE : APIS.PROFILE.AVATAR_UPDATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tokenData}` },
        body: params,
      })
        .then(response => response.json())
        .then(resp => {
          if (resp?.status == 200) {
            // Handle success  
            resolve(resp.message);
          } else {
            reject(resp.message);
          }
        })
        .catch(error => {
          // Handle error
          console.error('Error:', error);
          reject(error.message);
        });
    })
  }
  const avtarSubmitHandler = async (file: any, type = 'profile') => {
    let formData = new FormData();
    if (type === 'company') {
      formData.append('company_logo', file);
      formData.append('slug', userData?.company?.slug);
      console.log('formData company==========', formData)
    } else {
      formData.append('avatar', file);
      formData.append('user_id', userData?.id);
      console.log('formData other==========', formData)
    }
    toast.promise(
      fileUploadImg(formData, type), {
      loading: 'Updating...',
      success: (msg: any) => {
        return <b>{msg}</b>
      },
      error: (msg: any) => { return <b>{msg}</b> },
    });
  }

  const handleFileChange = (event: any, type = 'user') => {
    const selectedFile = event.target.files[0];
    // Do something with the selected file, e.g., display its name
    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Base64 string representation of the selected file
        const base64String = reader.result as string | null;
        if (base64String !== null) {
          if (type === 'company') {
            setCompanyImg(base64String);
            avtarSubmitHandler(selectedFile, 'company');
          } else {
            setUserImg(base64String);
            avtarSubmitHandler(selectedFile, 'profile');
          }
        }
        // You can use the base64String as needed (e.g., set it in the state)
      };
      // Read the selected file as a Data URL (Base64)
      reader.readAsDataURL(selectedFile);
    }
    // setSelectedFiles(event.target.files);
  };

  const updateProfile = (params: any) => {
    return new Promise((resolve, reject) => {
      profileAPI.profileUpdate(params, (msg: any, resp: any) => {
        if (resp?.status == 200) {
          resolve(msg);
        } else {
          reject(msg);
        }
      }, (msg: any) => {
        reject(msg);
      })
    //   fetch(APIS.PROFILE.UPDATE, {
    //     method: 'PUT',
    //     headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tokenData}` },
    //     body: JSON.stringify(params),
    //   })
    //     .then(response => response.json())
    //     .then(resp => {
    //       if (resp?.status == 200) {
    //         // Handle success  
    //         resolve(resp.message);
    //       } else {
    //         reject(resp.message);
    //       }
    //     })
    //     .catch(error => {
    //       // Handle error
    //       console.error('Error:', error);
    //       reject(error.message);
    //     });
    })
  }

  const saubmitFormHandler = async (data: any) => {
    console.log('data==========', data) 
    const params = {
      full_name: data.first_name + ' ' + data.last_name,
      // salutation: data.salutation,
      // salutation: getSelectedValue(data.salutation, 'value', salutationList),
      salutation: data.salutation?.value,
      first_name: data.first_name,
      last_name: data.last_name,
      phone: data.phone,
      about: data.about,
      licenses: data?.licenses? data?.licenses?.map((item: any) => item.value) : [], 
      company: {
        status: 1,
        name: data.company_name,
        license_number: data.license_number,
        website: data.website,  
        languages: data?.languages ? data?.languages?.map((item: any) => item.value) : [],
        addresses: [
          {
            // location_country_id: data?.location_country_id,
            location_state_id: data?.location_state_id?.value,
            location_city_id: data?.location_city_id,
            location_type: 1,
            zipcode: data.zipcode,
            addressline_one: data.office_address,

          }
        ]



    // "company": {
    //     "slug": "brothers-pvt-ltd",
    //     "description": null,
    //     "addresses": [
    //         {
    //             "location_country_id": 231,
    //             "location_state_id": 35,
    //             "location_city_id": 90,
    //             "location_type": 1,
    //             "lat": null,
    //             "lng": null,
    //             "zipcode": "700091",
    //             "addressline_one": null,
    //             "addressline_two": null
    //         }
    //     ]
    // }


      },

    }
    toast.promise(
      updateProfile(params), {
      loading: 'Updating...',
      success: (msg: any) => {
        return <b>{msg}</b>
      },
      error: (msg: any) => { return <b>{msg}</b> },
    });
  }


  return (

    <Layout>
      <form onSubmit={handleSubmit(saubmitFormHandler)} encType="multipart/form-data">
        <div data-aos="fade-up" data-aos-duration="1000">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-15">
                  <h1 className="mb-0 text-xxl">
                    Welcome, <span className="text-accent">Paul</span>
                  </h1>
                  <Dropdown>
                    {/* Main Dropdown */}
                    <Dropdown.Toggle
                      variant="primary"
                      id="dropdown-basic"
                      className="btn btn-primary dropdown-toggle rate_checker"
                    >
                      Rate Calculator <i className="mdi mdi-chevron-down"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#action1">
                        Polly Rate Checker
                      </Dropdown.Item>

                      {/* Sub Dropdown */}
                      <Dropdown drop="end">
                        <Dropdown.Toggle
                          as="a"
                          className="dropdown-item"
                          href="#"
                        >
                          Lender Price Rate Checker
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item href="#subaction1">
                            275 BPS
                          </Dropdown.Item>
                          <Dropdown.Item href="#subaction2">
                            200 BPS
                          </Dropdown.Item>
                          <Dropdown.Item href="#subaction2">0 BPS</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <div className="right-progressbar">
                  {/* Progress Percentage */}
                  <span
                    className="progress-percent"
                    style={{ left: `${progressValue}%` }}
                  >
                    {progressValue}%
                  </span>

                  {/* Progress Bar */}
                  <div className="progress">
                    <ProgressBar
                      now={progressValue}
                      label={`${progressValue}%`}
                      style={{ width: "100%" }}
                    />
                  </div>

                  {/* Progress Range */}
                  <div className="d-flex justify-content-between">
                    <span>0</span>
                    <span>100%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Row>
            <Col lg={12}>
              {/* Personal Details Section */}
              <Card className="mb-3">
                <Card.Body>
                  <div className="section-heading">
                    <h2>Personal Details</h2>
                  </div>
                  <Row>
                    {/* Profile Picture Section */}
                    <Col sm={2}>
                      <div className="d-flex justify-content-center align-items-center flex-column mb-5 profile-pic-section">
                        <h4>Your Picture</h4>
                        <div className="profile-pic-upload">
                          <img className="rounded-circle avatar-xl" src={userImg} alt={userData?.first_name} />
                          <div className="profile-pic-input ">
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="avatar"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <input
                                  accept='image/png,image/jpg,image/jpeg,.pdf'
                                  type="file" name={name}
                                  onChange={(e) => {
                                    handleFileChange(e, 'user');
                                  }}
                                />
                              )}
                            />
                            <span className="profile-pic-edit-icon cursor-pointer ">
                              <i className="edit-icon-w"></i>
                            </span>
                          </div>
                        </div>
                        <div className="profile-email">
                          <label>
                            Preferred Email <sup>*</sup>
                          </label>
                          <p>{userData?.email}</p>
                        </div>
                        <Alert
                          variant="success"
                          className="d-flex align-items-center px-3 py-2 mb-2"
                        >
                          <span>Email change is disabled!</span>
                        </Alert>
                      </div>
                    </Col>

                    {/* Personal Information Section */}
                    <Col sm={10}>
                      <Row className="mb-3">
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label className="select_input_label">Title <sup>*</sup></Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="salutation"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <Select
                                  name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  options={salutationList}
                                  defaultValue={{ value: 1, lable: 'Mr.' }}
                                  className="form-control select_input"
                                />
                              )}
                            />
                            {/* <i className="title-icon"></i> */}
                            <p className="pt-2"><strong>Ex :</strong> Mortgage Loan Originator, Account Executive </p>
                            <Error error={errors["salutation"]} />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label>First Name <sup>*</sup></Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="first_name"
                              rules={{ required: 'First Name is required' }}
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <input type="text" name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  className="form-control" placeholder="Paul"
                                />
                              )}
                            />
                            <i className="user-icon"></i>
                            <Error error={errors["first_name"]} />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label>Last Name <sup>*</sup></Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="last_name"
                              rules={{ required: 'Last Name is required' }}
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <input type="text" name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  className="form-control" placeholder="Adams"
                                />
                              )}
                            />
                            <i className="user-icon"></i>
                            <Error error={errors["last_name"]} />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group className="form-group">
                            <Form.Label>Phone <sup>*</sup></Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="phone"
                              rules={{ required: 'Phone is required' }}
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <input type="text" name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  className="form-control" placeholder="6234180019"
                                />
                              )}
                            />
                            <i className="phone-icon"></i>
                            <Error error={errors["phone"]} />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="form-group">
                            <Form.Label className="select_input_label">Licensed In</Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="licenses"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <Select
                                  name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  options={licensesList}
                                  defaultValue={value}
                                  isClearable={true}
                                  isMulti={true}
                                  className="form-control select_input"
                                />
                              )}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group className="form-group">
                            <Form.Label>About</Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="about"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <textarea name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value} rows={4}
                                  className="form-control" />
                              )}
                            />
                            <Error error={errors["about"]} />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Company Details Section */}
              <Card className="mb-4">
                <Card.Body>
                  <div className="section-heading"><h2>Company Details</h2></div>
                  <Row>
                    {/* Company Logo Section */}
                    <Col sm={2}>
                      <div className="d-flex justify-content-center align-items-center flex-column mb-5 profile-pic-section">
                        <h4>Team/Company Logo</h4>
                        <div className="profile-pic-upload">
                          <img className="rounded-circle avatar-xl" src={companyImg} alt={userData?.company?.name} />
                          <div className="profile-pic-input  ">
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="attachments"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <input
                                  accept='image/png,image/jpg,image/jpeg,.pdf'
                                  type="file" name={name}
                                  onChange={(e) => {
                                    handleFileChange(e, 'company');
                                  }}
                                />
                              )}
                            />
                            <span className="profile-pic-edit-icon cursor-pointer">
                              <i className="edit-icon-w"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* Company Information Section */}
                    <Col sm={10}>
                      <Row className="mb-3">
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label>Company Name</Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="company_name"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <input type="text" name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  className="form-control pr-50" placeholder="Mortgage Support"
                                />
                              )}
                            />
                            <i className="business-icon"></i>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label>License Number</Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="license_number"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <input type="text" name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  className="form-control" placeholder="#41030784"
                                />
                              )}
                            />
                            <i className="numbers-icon"></i>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label>Website</Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="website"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <input type="text" name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  className="form-control pr-50" placeholder="www.mortgagesupport.com"
                                />
                              )}
                            />
                            <i className="website-icon"></i>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label>Office Address</Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="office_address"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <textarea name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value} rows={4}
                                  className="form-control" placeholder=""
                                />
                              )}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label>Branch Address</Form.Label>

                            <Controller
                              defaultValue={""}
                              control={control}
                              name="branch_address"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <textarea name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value} rows={4}
                                  className="form-control" placeholder=""
                                />
                              )}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label>Local Address</Form.Label>

                            <Controller
                              defaultValue={""}
                              control={control}
                              name="local_address"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <textarea name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value} rows={4}
                                  className="form-control" placeholder=""
                                />
                              )}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label>City</Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="city"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <input name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  className="form-control" placeholder="Buckeye"
                                />
                              )}
                            />
                            <i className="city-icon"></i>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label className="select_input_label">State</Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="location_state_id"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <Select name={name} onChange={onChange}
                                  onBlur={onBlur} options={stateList}
                                  className="form-control select_input"
                                />
                              )}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="form-group">
                            <Form.Label>Zip</Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="zip"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <input name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  className="form-control" placeholder="85396"
                                />
                              )}
                            />
                            <i className="zip-icon"></i>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={12}>
                          <Form.Group className="form-group">
                            <Form.Label className="select_input_label">Additional Spoken Languages</Form.Label>
                            <Controller
                              defaultValue={""}
                              control={control}
                              name="languages"
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                              }) => (
                                <Select
                                  name={name}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  options={languagesList}
                                  defaultValue={value}
                                  isClearable={true}
                                  isMulti={true}
                                  className="form-control select_input"
                                />
                              )}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <Card>
                <Card.Body>
                  <Row>
                    <Col md={12}>
                      <div className="section-heading">
                        <h2>Two Factor Authentication</h2>
                      </div>
                      <form>
                        <div className="row">
                          <div className="col-sm-2">
                            <div className="d-flex justify-content-center align-items-center flex-column mb-5 profile-pic-section">
                              <div className="profile-pic-upload">
                                <img
                                  className="rounded-circle avatar-xl"
                                  alt="200x200"
                                  src="assets/images/review/image 21.jpg"
                                  data-holder-rendered="true"
                                />
                                <a href="#" className="profile-pic-edit-icon">
                                  <i className="edit-icon-w"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-10">
                            <div className="mb-3 twostep_descriptiontxt">
                              <p>
                                Your account is protected with 2-Step Verification
                              </p>
                              <p>
                                Prevent hackers from accessing your account with
                                an additional layer of security.
                              </p>
                              <p>
                                Unless you're signing in with a passkey, you'll be
                                asked to complete the most secure second step
                                available on your account. You can update your
                                second steps and sign-in options any time from
                                following settings.
                              </p>
                              <a href="#" className="two_stepverificationbtn d-none">
                                Turn on 2- Step Verification
                              </a>
                              <a href="#" className="pink-btn">
                                Turn off 2- Step Verification
                              </a>
                              <p className="twostepflow_txt mt-3">
                                Please use any one of the following steps as 2nd
                                step <br />
                                verification
                              </p>
                              <div className="twostep_raioctrl">
                                <div className="twostep_raio active">
                                  <div className="custom-control custom-radio custom-radio-outline custom-radio-primary ">
                                    <input
                                      type="radio"
                                      id="customRadiooutlinecolor1"
                                      name="customRadiooutlinecolor1"
                                      className="custom-control-input"
                                      checked
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="customRadiooutlinecolor1"
                                    >
                                      <img src="assets/images/review/Phone Ringing2.png" />{" "}
                                      Phone no
                                    </label>
                                  </div>
                                  <a href="#" className="add_phoneno">
                                    +14844578249
                                  </a>
                                </div>
                                <div className="twostep_raio">
                                  <div className="custom-control custom-radio custom-radio-outline custom-radio-primary ">
                                    <input
                                      type="radio"
                                      id="customRadiooutlinecolor2"
                                      name="customRadiooutlinecolor1"
                                      className="custom-control-input"
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="customRadiooutlinecolor2"
                                    >
                                      <img src="assets/images/review/Qr Code.png" />{" "}
                                      Google Authenticator
                                    </label>
                                  </div>
                                  <a href="#" className="add_phoneno">
                                    + Authenticator
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              {/* Action Buttons */}
              <div className="d-flex gap-3 justify-content-center page-main-btn mb-5">
                <Button variant="primary" type="submit" size="lg">Update Information </Button>
                <Button variant="outline-danger" size="lg">Delete Account</Button>
              </div>
            </Col>
          </Row>
        </div>
      </form>
    </Layout>
  );
};

export default Profile;
